(function() {
  const callback = () => {
    const pumperWrapper = document.querySelector('#prvw__bundle_container');
    const pumperTextBlocks = pumperWrapper?.querySelectorAll('.block__cbwrapper .template_4_label .template_4_block__cbmain--content h3');

    if (pumperWrapper && pumperTextBlocks.length > 0) {
      pumperTextBlocks.forEach((block, index) => {
        if (window.pumperTextTranslation[index]) {
          block.innerText = window.pumperTextTranslation[index];
        }
      });

      pumperObserver.disconnect();
    }
  }

  const pumperObserver = new MutationObserver(callback);
  const target = document.querySelector('.product-single__form');

  pumperObserver.observe(target, {childList: true});
})();
